import { backend_url } from 'utils/services'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react'

export const contactApi = createApi({
  reducerPath: 'contactApi',
  baseQuery: fetchBaseQuery({
    baseUrl: backend_url + '/contact'
  }),
  endpoints: (builder) => ({
    sendEnquiry: builder.mutation({
      query: (data) => ({
        url: '/enquiry',
        method: 'POST',
        body: data
      })
    })
  })
})

export const { useSendEnquiryMutation } = contactApi

export default contactApi.reducer
